import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { ObjectFieldValues } from "../../../../../../api/types/objectTypes";
import type { WorkflowActivityChangeSet } from "../../../../../../api/types/workflowTypes";
import type { TransactionEditState } from "./transactionEditState";

export interface Props {
  activityChangeSet: WorkflowActivityChangeSet;
  allEntities: ObjectFieldValues[];
  editState: TransactionEditState;
  setEditState: React.Dispatch<React.SetStateAction<TransactionEditState>>;
}

const TransactionEditContext = createContext<Props | undefined>(undefined);

export const TransactionEditContextProvider = ({ children, ...props }: PropsWithChildren<Props>) => (
  <TransactionEditContext value={props}>{children}</TransactionEditContext>
);

export default TransactionEditContext;
